// extracted by mini-css-extract-plugin
export default {"control":"Checkout_control__BNiUB","wrapper":"Checkout_wrapper__X+S7W","confirm":"Checkout_confirm__3Oocu","price":"Checkout_price__EwCTK"};